import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { setDict, t } from "@/i18n";

const LangCtx = createContext(null);

async function loadDict(lang) {
  if (lang === "it") return {};
  const { data } = await api.get(`/i18n/${lang}`, { timeout: 90000 });
  return data.strings;
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("nv_lang") || "it");
  const [ready, setReady] = useState(lang);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    loadDict(lang)
      .then((d) => {
        if (!alive) return;
        setDict(d);
        document.documentElement.lang = lang;
        localStorage.setItem("nv_lang", lang);
        setReady(lang);
      })
      .catch(() => {
        toast.error(t("Traduzione non disponibile, riprova più tardi"));
        setLang(ready);
      })
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  return (
    <LangCtx.Provider value={{ lang: ready, setLang, loading }}>
      <div key={ready} className="contents">{children}</div>
      {loading && lang !== ready && (
        <div className="fixed inset-0 z-[2000] grid place-items-center bg-black/60 backdrop-blur-sm" data-testid="lang-loading">
          <div className="nv-card px-8 py-6 font-display text-2xl font-extrabold uppercase">{t("Traduzione in corso…")}</div>
        </div>
      )}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
